// extracted by mini-css-extract-plugin
export var container = "_si-0";
export var inputWidth = "_si-1";